import React, { ChangeEvent } from "react";

type PasswordFieldProps = {
  value: string | undefined;
  onChange: (event: ChangeEvent<HTMLInputElement>) => void;
}

type PasswordFieldBoxProps = {
  label: string;
  value: string | undefined;
  onChange: (event: ChangeEvent<HTMLInputElement>) => void;
  required?: boolean;
}

export const PasswordField: React.FC<PasswordFieldProps> = ({ value, onChange }) => (
  <div className="contact-box__ct">
    <input type="password" className="input input--pw" placeholder="*********" value={value} onChange={onChange} />
  </div>
);

export const PasswordFieldBox: React.FC<PasswordFieldBoxProps> = ({ label, value, onChange, required = false }) => (
  <div className="contact-box__item">
    <label className="contact-box__ttl">
      <span>{label}</span>
      { required && <small>必須</small> }
    </label>
    <PasswordField  value={value} onChange={onChange} />
  </div>
);
